import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-omnio-black py-12 border-t border-omnio-charcoal">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex flex-col items-center md:items-start">
          <span className="text-omnio-white font-bold text-xl tracking-widest uppercase mb-2">OMNIO</span>
          <span className="text-omnio-gray text-sm font-light">A living system for your lifestyle.</span>
        </div>
        
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-omnio-gray font-light">
          <Link to="/privacy-policy" className="hover:text-omnio-white transition-colors">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-omnio-white transition-colors">Terms of Service</Link>
          <Link to="/account-deletion" className="hover:text-omnio-white transition-colors">Account Deletion</Link>
          {/* <a href="#!" className="hover:text-omnio-white transition-colors">Twitter</a>
          <a href="#!" className="hover:text-omnio-white transition-colors">Instagram</a> */}
        </div>
      </div>
    </footer>
  );
}
